import { useEffect, useState } from 'react';
/**
 * Detects whether a video element is portrait-oriented (height > width).
 * Fires on loadedmetadata and also handles cached videos via readyState >= 1 fallback.
 */
const usePortraitDetection = (videoRef, onPortraitDetected) => {
    const [isPortrait, setIsPortrait] = useState(false);
    useEffect(() => {
        const videoEl = videoRef.current;
        if (!videoEl)
            return;
        const detect = () => {
            if (videoEl.videoWidth > 0 && videoEl.videoHeight > 0) {
                const portrait = videoEl.videoHeight > videoEl.videoWidth;
                setIsPortrait(portrait);
                onPortraitDetected === null || onPortraitDetected === void 0 ? void 0 : onPortraitDetected(portrait);
            }
        };
        videoEl.addEventListener('loadedmetadata', detect);
        // Fallback: metadata already loaded for cached videos
        if (videoEl.readyState >= 1) {
            detect();
        }
        return () => {
            videoEl.removeEventListener('loadedmetadata', detect);
        };
    }, [videoRef, onPortraitDetected]);
    return isPortrait;
};
export default usePortraitDetection;
